import { jsxs as h, jsx as l } from "react/jsx-runtime";
import { Container as S, ShareIcon as d, ShareText as u, ShareButtonMobile as x } from "./style.js";
import { DealAction as C } from "../../../types/Deal/index.js";
import { useTranslation as b } from "../../../hooks/useTranslation/index.js";
import { ShareFromSquare as f, Whatsapp as I } from "@pelando/fontawesome/icons";
const T = ({
  ariaLabel: o,
  isInactive: t,
  height: e = "32px",
  padding: r = "4px 8px",
  marginBottom: n = "4px",
  locale: i,
  children: a
}) => /* @__PURE__ */ h(
  S,
  {
    style: {
      height: e,
      padding: r,
      marginBottom: n
    },
    children: [
      /* @__PURE__ */ l(
        d,
        {
          icon: i === "en-US" ? f : I,
          "aria-label": o,
          "aria-disabled": t
        }
      ),
      a && /* @__PURE__ */ l(u, { children: a })
    ]
  }
);
function B({
  id: o,
  className: t,
  isInactive: e,
  height: r,
  padding: n,
  children: i,
  marginBottom: a,
  locale: p,
  dispatch: m
}) {
  const { t: c } = b("common"), s = () => {
    m({ type: C.CLICK_TO_SHARE, payload: { id: o } });
  };
  return /* @__PURE__ */ l(
    x,
    {
      title: c("deal-whatsapp-button"),
      onClick: () => {
        s();
      },
      className: t,
      children: T({
        ariaLabel: c("deal-whatsapp-icon-aria-label"),
        isInactive: e,
        height: r,
        padding: n,
        marginBottom: a,
        locale: p,
        children: i
      })
    }
  );
}
export {
  B as DealCardShareButton,
  T as getShareContent
};
